import { Component, OnInit } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-cgrp-off-option-dialog',
  templateUrl: './cgrp-off-option-dialog.component.html',
  styleUrls: ['./cgrp-off-option-dialog.component.scss']
})
export class CgrpOffOptionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
